export const filterDirect = (orders, setOrders) => {
  const directOrders = []
  orders.forEach((order) => {
    if (!order.bus) {
      directOrders.push(order)
    }
  })
  setOrders(directOrders)
}
